import { useMutation } from 'react-query'
import { rewardActivityService } from 'src/services/reward-activity.service'
import { IChallengesBaseWithId } from 'src/types'

export const useDownloadRewardActivityCsv = () => {
  return useMutation(
    (params: IChallengesBaseWithId) =>
      rewardActivityService.getRewardActivityCsv({ challange_id: params.id }),
    {
      onSuccess: (data, variables) => {
        // Create a Blob from the CSV data
        if (!data) {
          return
        }
        const blob = new Blob([data], { type: 'text/csv' })
        const url = window.URL.createObjectURL(blob)

        // Create an anchor element and trigger a download
        const a = document.createElement('a')
        a.href = url
        a.download = `${variables.name}_challenge_${variables.start_date}_${variables.end_date}.csv`
        document.body.appendChild(a)
        a.click()

        a.remove()
        window.URL.revokeObjectURL(url)
      },
      onError: (error) => {
        console.error('CSV download failed:', error)
      },
    },
  )
}
